import { connect } from "react-redux";
import { postJSONexpectText } from "../netzwerk/FetchWithToken";

import ThinkGreenInfoPanel from "./ThinkGreenInfoPanel";

export default connect(state => ({
	think_green: state.ablauf.statistics.think_green,
	settings: state.settings.time,
	auth: state.user
}), () => ({
	doReset: () => {
		postJSONexpectText("/think_green/reset", {});
	}
}))(ThinkGreenInfoPanel);
